import { routes as ROUTES } from '@/constants/routes/routes';

const { appRoutes: applicationRoutes } = ROUTES;

export const sidebarLinks = [
  {
    text: 'device.management',
    topic: 'devices',
    hideChildren: false,
    permission_id: 'deviceManagement',
    children: [
      /*
      {
        text: 'dashboard.title',
        icon: 'mdi-view-dashboard',
        permission_id: 'deviceList',
        url: applicationRoutes.dashboard.url
      },
      */
      {
        id: 'device-list',
        text: 'device.list.title_list',
        icon: 'mdi-cellphone-link',
        permission_id: 'deviceList',
        url: applicationRoutes.devicesList.url
      },
      {
        id: 'history',
        text: 'device.history.title',
        icon: 'mdi-history',
        permission_id: 'history',
        url: applicationRoutes.devicesHistory.url
      },
      {
        id: 'personalisation',
        text: 'device.personalisation.title',
        icon: 'custom-personalisation',
        permission_id: 'personalisation',
        url: applicationRoutes.personalisationList.url
      }
    ]
  },
  {
    text: 'map.tolling',
    topic: 'tolling',
    permission_id: 'tollZonesManagement',
    hideChildren: false,
    children: [
      {
        id: 'overview',
        icon: 'custom-overview',
        text: 'map.tolldomains.overview.title',
        permission_id: 'geometryManagement',
        url: applicationRoutes.tollDomainsOverview.url
      },
      {
        id: 'rules',
        icon: 'custom-rules',
        text: 'map.tolldomains.rules',
        permission_id: 'rules',
        url: applicationRoutes.tollDomainsRules.url
      },
      {
        id: 'dsrc-instances',
        icon: 'custom-dsrc-instances',
        text: 'map.tolldomains.instance',
        permission_id: 'dsrcInstance',
        url: applicationRoutes.tollDomainsInstance.url
      },
      {
        id: 'dat',
        icon: 'custom-dat',
        text: 'map.tolldomains.dat',
        permission_id: 'dat',
        url: applicationRoutes.tollDomainsDAT.url
      }
    ]
  },
  {
    text: 'access.management',
    topic: 'access-management',
    permission_id: 'accessManagement',
    hideChildren: false,
    children: [
      {
        id: 'user-list',
        icon: 'custom-user-list',
        text: 'access.user.list',
        permission_id: 'userList',
        url: applicationRoutes.userManagementList.url
      },
      {
        id: 'user-role',
        icon: 'custom-user-role',
        text: 'access.user.role',
        permission_id: 'userRole',
        url: applicationRoutes.userManagementRole.url
      }
    ]
  }
];

export default sidebarLinks;
